(function () {
    "use strict";
    angular
        .module('skillBuilderSaaS')
        .controller("AddItemsModalCtrl", ["learningItemResource", "messageService", "$translate", "$scope", "$timeout", "DTOptionsBuilder", "DTColumnDefBuilder", "DTDefaultOptions", '_', addItemsModalCtrl]);
    function addItemsModalCtrl(learningItemResource, messageService, $translate, $scope, $timeout, DTOptionsBuilder, DTColumnDefBuilder, DTDefaultOptions, _) {
        var vm = this;
        DTDefaultOptions.setLoadingTemplate("<p class='text-center'><img src='/images/ajaxindicator.gif' class='control-label'></p>");
        vm.lang = $translate.proposedLanguage() || $translate.use();
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
            .withOption("processing", true)
            .withOption("responsive", { details: { type: "column" } })
            .withOption("stateDuration", -1)
            .withPaginationType("full_numbers")
            .withOption("order", [1, "asc"])
            .withOption("fnDrawCallback", function () {
            $timeout(function () {
                vm.checkedAll = false;
                vm.clearSelection();
                $scope.$apply();
            });
        })
            .withBootstrap();
        vm.clearSelection = function () {
            vm.checkedItems = {};
            vm.checkedItems = _.where(vm.learningItems, { checked: true });
            for (var i = 0; i < vm.checkedItems.length; ++i) {
                vm.checkedItems[i].checked = false;
            }
        };
        vm.selectAllClicked = function () {
            vm.selectItems = []; //cbox.items contains all checked checkboxes
            var oTable = vm.dtInstance.DataTable;
            var anNodes = $("#learningPaths tbody tr");
            for (var i = 0; i < anNodes.length; ++i) {
                var rowData = oTable.row(anNodes[i]).data();
                if (rowData) {
                    vm.selectItems.push(_.find(vm.learningItems, { code: rowData[2] })); //rowData 2 is code
                    vm.selectItems[i].checked = vm.checkedAll;
                }
            }
        };
        vm.rowClicked = function (item) {
            item.checked = !item.checked;
            vm.itemChecked();
        };
        vm.itemChecked = function () {
            var items = []; //cbox.items contains all checked checkboxes
            var oTable = vm.dtInstance.DataTable;
            var anNodes = $("#learningPaths tbody tr");
            for (var i = 0; i < anNodes.length; ++i) {
                var rowData = oTable.row(anNodes[i]).data();
                items.push(_.find(vm.learningItems, { code: rowData[2] })); //rowData 2 is code
            }
            vm.checkedAll = _.every(items, { checked: true });
        };
        vm.dtColumnDefs = [
            DTColumnDefBuilder.newColumnDef(0).notSortable()
        ];
        vm.dtInstanceCallback = function (instance) {
            vm.dtInstance = instance;
        };
        vm.search = function (value) {
            vm.dtInstance.DataTable.search(value).draw();
        };
        learningItemResource.getPublishedItemList(function (data) {
            vm.updateList(data);
        }, function () {
            messageService.error("common.genericError");
        });
        vm.updateList = function (data) {
            vm.learningItems = _.filter(data, function (obj) {
                return _.find($scope.$parent.vm.learningPathVersion.items, { itemId: obj.itemId }) === undefined;
            });
        };
        vm.addItemsAndClose = function () {
            var list = _.where(vm.learningItems, { checked: true });
            if (list.length !== 0) {
                messageService.success("learningPath.add.itemsAdded");
                $scope.$close(list);
            }
            else {
                messageService.error("learningPath.add.error.selectAtLeastOne");
            }
        };
        vm.addItems = function () {
            var list = _.where(vm.learningItems, { checked: true });
            if (list.length !== 0) {
                var updatedList = $scope.$parent.addItems(list);
                vm.dtSearch = "";
                $scope.$parent.vm.learningPathVersion.items = updatedList;
                vm.updateList(vm.learningItems);
                messageService.success("learningPath.add.itemsAdded");
            }
            else {
                messageService.error("learningPath.add.error.selectAtLeastOne");
            }
        };
    }
}());
